/* Settings variables */
export const REQUEST_TIMEOUT_MS = 300000;
